module.exports = __webpack_public_path__ + "img/svnr_thumbnail.f5dfae4b.png";